export const messages = {
  en: {
    videoControl: {
      title: 'Video Control'
    },
    cameraControlVideo: {
      camera: 'Camera',
      fourWay: 'Four Way',
      sixWay: 'Six Way',
      getVideoUrlError: 'Failed to get video URL'
    },
    selectVideoMachine: {
      title: 'Select Video Machine',
      monitorArea: 'Monitor Area',
      camera: 'Camera',
      loadAreasError: 'Failed to load monitor areas',
      loadMachinesError: 'Failed to load monitor machines'
    }
  },
  zh: {
    videoControl: {
      title: '视频控制'
    },
    cameraControlVideo: {
      camera: '摄像头',
      fourWay: '四路',
      sixWay: '六路',
      getVideoUrlError: '获取视频地址失败'
    },
    selectVideoMachine: {
      title: '选择视频设备',
      monitorArea: '监控区域',
      camera: '摄像头',
      loadAreasError: '加载监控区域失败',
loadMachinesError: '加载监控设备失败'
    }
  },
  'zh-TW': {
    videoControl: {
      title: '視頻控制'
    },
    cameraControlVideo: {
      camera: '攝像頭',
      fourWay: '四路',
      sixWay: '六路',
      getVideoUrlError: '獲取視頻地址失敗'
    },
    selectVideoMachine: {
      title: '選擇視頻設備',
      monitorArea: '監控區域',
      camera: '攝像頭',
      loadAreasError: '加載監控區域失敗',
      loadMachinesError: '加載監控設備失敗'
    }
  }
}